import React, { FC } from 'react';
import { FormProvider } from 'react-hook-form';

import { IFormProps } from './interfaces';

const Form: FC<IFormProps> = ({
  children,
  formMethods,
  onSubmit,
  className,
}) => {
  const { handleSubmit } = formMethods;

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)} className={className}>
        {children}
      </form>
    </FormProvider>
  );
};

export default Form;
